/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 * 
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 * 
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the context for the currently loaded master group.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/*
 * Used to create a context.
 */
import * as React from 'react';

/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */


/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */

export enum FieldErrorOption {
    AlwaysShowAllErrors = 1,
    AlwaysHideErrors = 2,
    AlwaysShowFirstError = 3,
    AlwaysHideErrorMessages = 4,
    AutoShowAllErrors = 5,
    AutoShowFirstError = 6,
    AutoHideErrorMessages = 7
}

interface IFormOptionsContext {
    fieldErrors?: FieldErrorOption;
    readOnly: boolean;
}

/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */

const FormOptionsContext = React.createContext<IFormOptionsContext>({
    fieldErrors: FieldErrorOption.AutoShowAllErrors,
    readOnly: false
});

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */

export default FormOptionsContext;